import React, { useRef } from "react";
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";
import { Link } from "react-router-dom";

export default function RishikeshRooms() {
    const sliderRef1 = useRef(null); 
    const sliderRef2 = useRef(null); 

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1600,
        autoplaySpeed: 3500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
    };

    const handlePrev = () => {
        sliderRef1.current?.slickPrev();
        sliderRef2.current?.slickPrev();
    };

    const handleNext = () => {
        sliderRef1.current?.slickNext();
        sliderRef2.current?.slickNext();
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrowleft" onClick={handlePrev}>
            <Icons name="Longarrow_left" />
        </div>
        <div className="default-arrowright" onClick={handleNext}>
            <Icons name="Longarrow_right" />
        </div>
        </>
    );


    const roomsData = [
        {
            title: "Deluxe",
            description: "Enjoy a luxurious jungle escape in these private cottages, featuring a personal in-room Jacuzzi for a spa-inspired retreat amidst nature.",
            image: "/image/rishikesh-room-1.webp",
            link: "/resort-de-coracao-rishikesh/deluxe"
        },
        {
            title: "Ganga Suite",
            description: "Unwind in these spacious standalone stays, featuring a full-sized bathtub and warm wooden interiors for a timeless forest-lodge feel.",
            image: "/image/rishikesh-room-2.webp",
            link: "/resort-de-coracao-rishikesh/ganga-suite"

        },
        {
            title: "Premium Suite",
            description: "An ideal retreat for nature lovers and pet owners, these airy cottages offer easy garden access and a spacious layout for the whole family.",
            image: "/image/rishikesh-room-3.webp",
            link: "/resort-de-coracao-rishikesh/premium-suite"
        },
        {
            title: "Suite",
            description: "Relax in these thoughtfully appointed rooms, featuring modern comforts and large windows overlooking the lush surrounding greenery.",
            image: "/image/rishikesh-room-4.webp",
            link: "/resort-de-coracao-rishikesh/suite"
        },
        {
            title: "Super Deluxe",
            description: "Our largest accommodation features two king beds, offering ample space for families to relax and spend quality time together.",
            image: "/image/rishikesh-room-5.webp",
            link: "/resort-de-coracao-rishikesh/super-deluxe"
        },
    ];

  return (
    <>
    <section className="rishikesh-rooms">
        <div className="container">
            <div className="row"> 
                <div className="col-lg-12">
                    <div className="rishroom-head">
                        <h3 className="heading">Spectacular Elevated Stays</h3>
                        <div className="rishroom-arrows"><CustomArrows /></div>
                    </div>
                </div>
            </div>
        </div>

        <div className="big-container">
            <div className="row"> 
                <div className="col-lg-7 col-md-7 no-rightpadd">
                    <div className="rishroom-image">
                        <Slider {...settings} ref={sliderRef1}>
                            {roomsData.map((item, index) => (
                                <img key={index} src={item.image} className="img-responsive" alt={item.title}/>
                            ))}
                        </Slider>
                        <img src="/image/rishikesh-roomlogo.webp" className="rishroom-imagelogo" alt="Logo" />
                    </div>
                </div>

                <div className="col-lg-5 col-md-5 no-leftpadd">
                    <div className="rishroom-content">
                        <Slider {...settings} ref={sliderRef2}>
                            {roomsData.map((item, index) => (
                            <div className="rishroom-slideitem" key={index}>
                                <div>
                                    <span className="sub-title">Our rooms</span>
                                    <h5 className="heading">{item.title}</h5>
                                </div>
                                <div>
                                    <p>{item.description}</p>
                                    <Link to={item.link} className="arrow-butn">Book {item.title} <img src="/image/right-arrow.svg" alt="arrow" /></Link>
                                </div>
                            </div>
                            ))}
                        </Slider>
                    </div>     
                </div>

            </div>
        </div>
    </section>  
    </>
  )
}
